var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popper',{attrs:{"visible-arrow":false,"trigger":_vm.trigger,"options":_vm.options}},[_c('div',{staticClass:"popper"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_c('template',{slot:"reference"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }